// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__iRm7m","message":"Loading_message__Rq6Hx","loading-spinner":"Loading_loading-spinner__9JToo","load":"Loading_load__edirJ"};